// Sélection des joueurs actifs
let joueurActifOne = document.querySelector('[data-character-one]');
let joueurActifTwo = document.querySelector('[data-character-two]');
let submitStart = document.querySelector('[data-game-run]');
if (submitStart) {
    submitStart.disabled = true;
}

// Gestion des messages utilisateur
let msgJoueursWrappers = document.querySelector('[data-game-msg]');
let msgJoueurs = document.createElement("p");
if (msgJoueursWrappers) {
    msgJoueurs.classList.add("p-msg");
    msgJoueurs.innerText = mapMessage(3);
    msgJoueursWrappers.replaceChildren(msgJoueurs);
}
// Gestion du nombre de joueurs
const nbPlayer = document.querySelectorAll('[data-st-nb-player]');
if (nbPlayer) { 
    // 3 MSG Sélectionnez le nombre de joueurs
    for (let index = 0; index < nbPlayer.length; index++) {
        const element = nbPlayer[index]; 
        element.addEventListener("change", (event) => {
            const form = document.querySelector('[data-player-nb]');
            if (form) {
                const listResetCharacter = document.querySelectorAll('[data-select-character]');
                for (let index = 0; index < listResetCharacter.length; index++) {
                    const resetPlayer = listResetCharacter[index];
                    resetPlayer.checked = false;
                    resetPlayer.disabled = false;
                    resetPlayer.removeAttribute("data-player-one");
                    resetPlayer.removeAttribute("data-player-two");
                }
                if (msgJoueurs) {
                    msgJoueurs.innerText = mapMessage(5); 
                }
                form.setAttribute("data-player-nb", event.target.value);
                form.setAttribute("data-player-current", 1);
                joueurActifOne.value = "";
                joueurActifTwo.value = "";
                submitStart.disabled = true;
            }      
        });
    }
}

// Process de sélection des joueurs
const listCharacter = document.querySelectorAll('[data-select-character]');
if (listCharacter) {
   for (let index = 0; index < listCharacter.length; index++) {
        const element = listCharacter[index]; 
        element.addEventListener("change", (event) => {
            let {selectCharacter} = element.dataset;
            const form = document.querySelector('[data-player-nb]');
            if (form) {
                //form.setAttribute("data-player-nb", event.target.value);
                let {playerNb, playerCurrent} = form.dataset;
                const listForOnePlayer = document.querySelectorAll('[data-select-character]');
                if (parseInt(playerNb) == 1) {
                    // 4 MSG Si vous êtes satisafaits de votre personnage, commençons le combat
                    if (msgJoueurs) {
                       msgJoueurs.innerText = mapMessage(4); 
                    }
                    for (let index = 0; index < listForOnePlayer.length; index++) {
                        const element4OnePlayer = listForOnePlayer[index];
                        element4OnePlayer.checked = false;
                        element4OnePlayer.removeAttribute("data-player-one");
                    }  
                    element.setAttribute("data-player-one", selectCharacter);
                    element.checked = true;
                    submitStart.disabled = false;
                    joueurActifOne.value = selectCharacter;
                } else {
                    
                   if (parseInt(playerCurrent) == 1) {
                    // 5 MSG Joueur 1 veuillez sélectionner votre personnage
                        if (msgJoueurs) {
                            msgJoueurs.innerText = mapMessage(6); 
                        }
                        element.checked = true;
                        form.setAttribute("data-player-current", 2);
                        element.setAttribute("data-player-one", selectCharacter);
                        joueurActifOne.value = selectCharacter;

                   } else if (parseInt(playerCurrent) == 2) {
                        const nbPlayerSelected = document.querySelector('input[data-player-one]');
                        if (nbPlayerSelected) {

                            if (parseInt(nbPlayerSelected.dataset.selectCharacter) == parseInt(selectCharacter)) {
                                // 7 MSG Joueur 2 à votre tour
                                if (msgJoueurs) {
                                    msgJoueurs.innerText = mapMessage(7); 
                                }
                                element.checked = true;
                                element.disabled = true;
                                form.setAttribute("data-player-current", 3);
                            } else {
                                // 6 MSG Validez votre sélection en recliquant sur votre personnage ou choisissez en un autre
                                if (msgJoueurs) {
                                    msgJoueurs.innerText = mapMessage(6); 
                                }
                                for (let index = 0; index < listForOnePlayer.length; index++) {
                                    const element4OnePlayer = listForOnePlayer[index];
                                    element4OnePlayer.checked = false;
                                    element4OnePlayer.removeAttribute("data-player-one");
                                }
                                element.checked = true;
                                element.setAttribute("data-player-one", selectCharacter);
                                joueurActifOne.value = selectCharacter;
                            } 
                        }     
                   } else if (parseInt(playerCurrent) == 3) {
                        const nbPlayer2Selected = document.querySelector('input[data-player-two]');
                        
                        if (nbPlayer2Selected) {
                            if (parseInt(nbPlayer2Selected.dataset.selectCharacter) == parseInt(selectCharacter)) {
                                element.checked = true;
                                element.disabled = true;
                                form.setAttribute("data-player-current", 4);
                                submitStart.disabled = false;
                                // 9 MSG Appuyez sur commencer pour combattre
                                if (msgJoueurs) {
                                    msgJoueurs.innerText = mapMessage(9); 
                                }
                            } else {
                                for (let index = 0; index < listForOnePlayer.length; index++) {
                                    const element4OnePlayer = listForOnePlayer[index];
                                    if (!element4OnePlayer.hasAttribute("data-player-one")) {
                                        element4OnePlayer.checked = false;
                                        element4OnePlayer.removeAttribute("data-player-two");
                                    }
                                }
                                element.checked = true;
                                element.setAttribute("data-player-two", selectCharacter);
                                joueurActifTwo.value = selectCharacter;
                            } 
                        } else {
                            // 8 MSG Validez votre sélection en recliquant sur votre personnage ou choisissez en un autre
                            if (msgJoueurs) {
                                msgJoueurs.innerText = mapMessage(8); 
                            }
                            element.setAttribute("data-player-two", selectCharacter);
                            joueurActifTwo.value = selectCharacter;
                        }
                   }
                }
            }   
        });
    } 
}

// Map message
function mapMessage(type = 1) {
    let availableMessages = {
        3: "Sélectionnez le nombre de joueurs",
        4: "Si vous êtes satisafaits de votre personnage, commençons le combat",
        5: "Joueur 1 veuillez sélectionner votre personnage",
        6: "Validez votre sélection en recliquant sur votre personnage ou choisissez en un autre",
        7: "Joueur 2 à votre tour",
        8: "Validez votre sélection en recliquant sur votre personnage ou choisissez en un autre",
        9: "Appuyez sur commencer pour combattre"
    }
    return availableMessages[type];
}